import React, { Component } from 'react';
import { isFunction } from 'lodash/lang';
import { AnalyticsConsumer } from '../providers/AnalyticsProvider';

const withSelectAnalytics = (analyticsConsumerProps) => (WrappedComponent) =>
  class AnalyticsInputComponent extends Component {
    static defaultProps = {
      trackValue: false,
    };

    handleChange = (sendAction) => (event, ...rest) => {
      const { changeEventAction, trackValue, onChange } = this.props;

      const label = trackValue ? event.target.value : null;

      if (isFunction(onChange)) {
        onChange(event, ...rest);
      }

      if (changeEventAction) {
        sendAction(changeEventAction, label);
      }
    };

    render() {
      const {
        analyticsActionName,
        analyticsLabel,
        analyticsCustomOptions,
        changeEventAction,
        trackValue,
        onClick,
        ...rest
      } = this.props;

      return (
        <AnalyticsConsumer {...analyticsConsumerProps}>
          {({ sendAction, dataProps }) => (
            <WrappedComponent {...dataProps} {...rest} onChange={this.handleChange(sendAction)} />
          )}
        </AnalyticsConsumer>
      );
    }
  };

export default withSelectAnalytics;
